import { Badge } from 'src/shadcn/components/ui/badge';
import { displayPrice } from 'src/utils/utils';

export const PricingTierPrice: React.FC<{
  monthly: number;
  annually: number;
  currentSelection: 'monthly' | 'annually';
  isCustom?: boolean;
}> = ({ monthly, annually, currentSelection, isCustom }) => {
  let price = monthly;
  let priceText = '/month';
  if (currentSelection === 'annually') {
    price = annually;
    priceText = '/year';
  }
  return (
    <div className='flex items-baseline'>
      {!isCustom && (
        <>
          <div className='text-3xl font-semibold'>
            {displayPrice(price, true)}
          </div>
          <div>{priceText}</div>
          {currentSelection === 'annually' && (
            <Badge variant={'success'} className='ml-3 rounded-lg'>
              {Math.round(((monthly * 12) / annually) * 100 - 100)}% off
            </Badge>
          )}
        </>
      )}
      {isCustom && <div className='text-3xl font-semibold'>Custom</div>}
    </div>
  );
};
